import { Modal } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useListingPickerStore } from '../Store/hooks/useStore'
import { ListingTable } from '../Table'

export const ListingPickerModal = () => {
  const { modalOpen, toggleModalOpen, setListingDetail } =
    useListingPickerStore(state =>
      pick(state, ['modalOpen', 'toggleModalOpen', 'setListingDetail'])
    )

  const handleOkChange = () => {
    setListingDetail()
    toggleModalOpen()
  }

  return (
    <Modal
      closable={false}
      open={modalOpen}
      title='选择挂牌资源'
      width={800}
      onCancel={toggleModalOpen}
      onOk={handleOkChange}
    >
      <ListingTable />
    </Modal>
  )
}
